import ColorThief from "colorthief";

export default defineNuxtPlugin(() => {
  const colorThief = new ColorThief();

  return {
    provide: {
      colorThief,
    },
  };
});
